import { render, staticRenderFns } from "./ScreenConfirmEmail.vue?vue&type=template&id=18f987b8&"
import script from "./ScreenConfirmEmail.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ScreenConfirmEmail.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f987b8')) {
      api.createRecord('18f987b8', component.options)
    } else {
      api.reload('18f987b8', component.options)
    }
    module.hot.accept("./ScreenConfirmEmail.vue?vue&type=template&id=18f987b8&", function () {
      api.rerender('18f987b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/ScreenConfirmEmail.vue"
export default component.exports